export default ($apnHelp) => {
  const $ratingButton = $('.apn-help__rating__buttons button', $apnHelp);
  $ratingButton.on('click.apnHelp', e => {
    const $button = $(e.currentTarget);
    $button.closest('.apn-help__rating__buttons').html('<div class="apn-copy txt-green margin-bottom">' + $button.data('ratingMessage') + '</div>');
    $.ajax({
      url: '/rpc.php?action=helprating',
      data: {
        'option': $button.data('ratingOption'),
        'id': $apnHelp.data('id')
      }
    });
  });

  const $helpRatingForm = $('#apn-help-rating-modal form');
  const $helpRatingModal = $('#apn-help-rating-modal');
  $('[name]', $helpRatingForm).on('input', e => {
    $('.error-msg', $(e.target).parent()).css('max-height', '0');
  });
  $helpRatingForm.on('submit', e => {
    e.preventDefault();
    const formData = $helpRatingForm.serialize();
    $(':input', $helpRatingForm).prop('disabled', true).siblings('.error-msg').css('max-height', '0');
    $.ajax({
      url: $helpRatingForm.attr('action'),
      method: $helpRatingForm.attr('method'),
      data: formData,
    }).done(response => {
      if (response.error.length > 0) {
        response.error.forEach(e => {
          const $formField = $('[name="' + e + '"]');
          $formField.siblings('.error-msg').css('max-height', '9em');
          if (e === 'sec') {
            const $captcha = $('.js_captcha', $helpRatingForm);
            $captcha.attr('src', $captcha.attr('src').split('?')[0] + '?' + (Math.random() * 10));
          }
        });
      } else {
        $helpRatingForm.remove();
        $('.js_success', $helpRatingModal).removeClass('hidden');
        $('#apn-rating-modal-label', $helpRatingModal).html('Vielen Dank!');
      }
    }).always(() => {
      $(':input', $helpRatingForm).prop('disabled', false);
    });
    return false;
  });
}
